import { recurringTaskApi } from './recurringTaskApiBase';
import { RecurringTaskView, RecurringTaskUpsertRequest } from './types';

export const recurringTaskMutationsApi = recurringTaskApi.injectEndpoints({
  endpoints: (builder) => ({
    upsertRecurringTask: builder.mutation<RecurringTaskView, RecurringTaskUpsertRequest>({
      query: (request) => ({
        url: 'RecurringTask',
        method: 'POST',
        body: request,
      }),
      invalidatesTags: ['RecurringTask', 'RecurringTaskList'],
    }),

    deleteRecurringTask: builder.mutation<boolean, string>({
      query: (id) => ({
        url: 'RecurringTask',
        method: 'DELETE',
        params: { id },
      }),
      invalidatesTags: ['RecurringTask', 'RecurringTaskList'],
    }),

    pauseRecurringTask: builder.mutation<RecurringTaskView, string>({
      query: (id) => ({
        url: 'RecurringTask/Pause',
        method: 'POST',
        params: { id },
      }),
      invalidatesTags: (_result, _error, id) => [
        { type: 'RecurringTask', id },
        'RecurringTaskList',
      ],
    }),

    resumeRecurringTask: builder.mutation<RecurringTaskView, string>({
      query: (id) => ({
        url: 'RecurringTask/Resume',
        method: 'POST',
        params: { id },
      }),
      invalidatesTags: (_result, _error, id) => [
        { type: 'RecurringTask', id },
        'RecurringTaskList',
      ],
    }),
  }),
});

export const {
  useUpsertRecurringTaskMutation,
  useDeleteRecurringTaskMutation,
  usePauseRecurringTaskMutation,
  useResumeRecurringTaskMutation,
} = recurringTaskMutationsApi;
